// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K9C2","colBig":"styles_colBig__3TnYE","colSmall":"styles_colSmall__3TsFe","shopifyNameWrapper":"styles_shopifyNameWrapper__26biQ"};